<script lang="ts">
  import type { MarketStylesLeadFormProps } from './types';
  import DynamicChildrenComponent from '$lib/components/DynamicChildrenComponent/DynamicChildrenComponent.svelte';

  export let entryId: MarketStylesLeadFormProps['entryId'];
  export let form: MarketStylesLeadFormProps['form'];
  export let options: MarketStylesLeadFormProps['options'];
  export let customCssClass: MarketStylesLeadFormProps['customCssClass'];

  // add areMarketStylesEnabled
  // @ts-expect-error  has an 'any'
  form[0].props.areMarketStylesEnabled = true;
</script>

<div
  class="MarketStylesLeadForm MarketStylesLeadForm-{entryId}-box-properties {customCssClass}"
  class:singleColumn={options.singleColumn}
  data-entry-id={entryId}
>
  <DynamicChildrenComponent children={form} />
</div>

<style lang="scss">
  @layer custom-components {
    :global {
      .MarketStylesLeadForm {
        &.singleColumn {
          .LeadFormSection {
            .row-with-2-columns {
              display: block;
            }
          }
        }
      }
    }
  }
</style>
